"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edit = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.Edit = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "edit", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M91.8 148.2L148.4 91.6L301.4 244.6L244.8 301.2000000000001L91.8 148.2zM40 40L128.2 71.8L72 127.6L40 40zM320 360C309 360 299 355.6 291.8 348.2L258.8 315.2L315.4 258.6L348.4 291.6C355.6 299 360 309 360 320C360 342 342 360 320 360z" : "M65 114.8L114.4 65.4L248.2 199.2L199 248.8L65 114.8zM19.8 20.2L97 48L47.8 96.8L19.8 20.2zM264.8 300.2C255.2 300.2 246.4 296.2 240 290L211.2 261.2L260.6 211.8L289.4000000000001 240.6C295.8 247 299.6 255.6 299.6 265.4C299.8 284.4 284.2000000000001 300.2 264.8 300.2z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.Edit.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.Edit.displayName = "Blueprint5.Icon.Edit";
exports.default = exports.Edit;
//# sourceMappingURL=edit.js.map